import {commaSeparate} from "../modules/helpers.js";
import {getTournamentEvent} from "../models/tournament.js";

const presidentsData = [
    {'name': 'Mr. Binsworth',
     'graphic': {"accessory": {"object": 36, "colors": ["0x724c32"]}, "accessory2": {"object": -1, "colors": null},
                 "accessory3": {"object": -1, "colors": null}, "body": {"object": 0, "colors": ["0xf5d0ae"]},
                 "bottoms": {"object": 0, "colors": ["0x5d3e29"]}, "elbow": {"object": -1, "colors": null},
                 "eyes": {"object": 0, "colors": ["0x000000"]}, "facepaint": {"object": -1, "colors": null},
                 "facialHair": {"object": -1, "colors": null}, "hair": {"object": 17, "colors": ["0xb7b7b7"]},
                 "knee": {"object": -1, "colors": null}, "shoes": {"object": 3, "colors": ["0x1E1E1E", "0x1E1E1E"]},
                 "tattoo": {"object": -1, "colors": null}, "torso": {"object": 47, "colors": ["0xe1e1e1"]},
                 "alternate_attires": []}
     },
    {'name': 'Miss Preston',
     'graphic': {"accessory": {"object": 37, "colors": ["0x313f4c"]},
                 "accessory2": {"object": 26, "colors": ["0xf4f4f4"]}, "accessory3": {"object": -1, "colors": null},
                 "body": {"object": 3, "colors": ["0xF7D1B9"]}, "bottoms": {"object": 0, "colors": ["0x191919"]},
                 "elbow": {"object": -1, "colors": null}, "eyes": {"object": 0, "colors": ["0x000000"]},
                 "facepaint": {"object": -1, "colors": null}, "facialHair": {"object": -1, "colors": null},
                 "hair": {"object": 47, "colors": ["0xcccccc", "0xcccccc"]}, "knee": {"object": -1, "colors": null},
                 "shoes": {"object": 3, "colors": ["0x2f2316", "0x2f2316"]}, "tattoo": {"object": -1, "colors": null},
                 "torso": {"object": 47, "colors": ["0x82a0c1"]}, "alternate_attires": []}
     },
    {'name': 'Mr. Cunningham',
     'graphic': {"accessory": {"object": 85, "colors": ["0x8a1437"]}, "accessory2": {"object": -1, "colors": null},
                 "accessory3": {"object": -1, "colors": null}, "body": {"object": 0, "colors": ["0xddbda0"]},
                 "bottoms": {"object": 0, "colors": ["0x141414"]}, "elbow": {"object": -1, "colors": null},
                 "eyes": {"object": 0, "colors": ["0x000000"]}, "facepaint": {"object": -1, "colors": null},
                 "facialHair": {"object": -1, "colors": null}, "hair": {"object": 0, "colors": ["0x090909"]},
                 "knee": {"object": -1, "colors": null}, "shoes": {"object": 3, "colors": ["0x020202", "0x020202"]},
                 "tattoo": {"object": -1, "colors": null}, "torso": {"object": 47, "colors": ["0x040404"]},
                 "alternate_attires": []}
     },
    {'name': 'Mr. Cruz',
     'graphic': {"accessory": {"object": 37, "colors": ["0x4d536e"]}, "accessory2": {"object": -1, "colors": null},
                 "accessory3": {"object": -1, "colors": null}, "body": {"object": 0, "colors": ["0xe4b486"]},
                 "bottoms": {"object": 0, "colors": ["0x2a2a2a"]}, "elbow": {"object": -1, "colors": null},
                 "eyes": {"object": 0, "colors": ["0x000000"]}, "facepaint": {"object": -1, "colors": null},
                 "facialHair": {"object": 11, "colors": ["0x565148"]}, "hair": {"object": 25, "colors": ["0x383838"]},
                 "knee": {"object": -1, "colors": null}, "shoes": {"object": 3, "colors": ["0x473437", "0x473437"]},
                 "tattoo": {"object": -1, "colors": null}, "torso": {"object": 47, "colors": ["0xa05b7f"]},
                 "alternate_attires": []}
     },
    {'name': 'Mr. Oliver',
     'graphic': {"accessory": {"object": 36, "colors": ["0x4e4e4e"]},
                 "accessory2": {"object": 39, "colors": ["0xd29c5c"]}, "accessory3": {"object": -1, "colors": null},
                 "body": {"object": 0, "colors": ["0xffd9b6"]}, "bottoms": {"object": 0, "colors": ["0x323232"]},
                 "elbow": {"object": -1, "colors": null}, "eyes": {"object": 0, "colors": ["0x000000"]},
                 "facepaint": {"object": -1, "colors": null}, "facialHair": {"object": -1, "colors": null},
                 "hair": {"object": 9, "colors": ["0xd4b583"]}, "knee": {"object": -1, "colors": null},
                 "shoes": {"object": 3, "colors": ["0x1e1e1e", "0x1e1e1e"]}, "tattoo": {"object": -1, "colors": null},
                 "torso": {"object": 47, "colors": ["0xc9dbe4"]}, "alternate_attires": []}
     }
];

async function getAnnualTournamentDialogs(annualTournament, companyData, event, previousTournaments, presidentName,
                                          participatingCompaniesNames, entriesSample, participationPoints, injuredParticipant,
                                          bribeCost) {  // get_annual_tournament_dialog
    let numberOfEntries = '';
    let bribed = false;
    let entriesSampleNames = '';
    if (companyData) {
        numberOfEntries = companyData['numberOfEntries'];
        bribed = companyData['bribed'];
    }

    // Get participating companies text
    let participatingCompaniesText;
    if (participatingCompaniesNames) {
        participatingCompaniesText = `${participatingCompaniesNames} have joined The Grand Invitational this time. ` +
            `Of course, top stars from the Indies will also be present.`;
    } else {
        participatingCompaniesText = "We are currently reaching out to top companies to join The Grand Invitational. " +
            "Besides them, top stars from the Indies will be participating.";
    }

    let normalInviteFirstText = "Hello again! It's that terrific time of the year where the wrestling world fights " +
        "to see who has the best talent.";
    if (previousTournaments && previousTournaments.length === 1) {
        normalInviteFirstText = "Hello there! I have some great news. Due to the success of the first TGI, the tournament " +
            "will be held again next month, and we plan to run it at the same time every year!";
    }

    let entriesVerb = 'are';
    if (entriesSample) {
        entriesSampleNames = commaSeparate(entriesSample.map(x => x.name));
        if (entriesSample.length === 1) {
            entriesVerb = 'is';
        }
    }

    // Get dialog objects
    const {firstInvite, normalInvite, inviteChoices, bribeChoice, beforeStartChoices,
        selectingEntries, declined, entriesSelected, starting, runningNight1, runningNight2, replacing} =
        getAnnualTournamentDialogObjects(annualTournament, presidentName, entriesSample, participationPoints,
            injuredParticipant, bribeCost, numberOfEntries, participatingCompaniesText, normalInviteFirstText,
            entriesSampleNames, entriesVerb);

    let dialogs = [];
    if (annualTournament.status === 'inviting') {
        if (!previousTournaments.length) {
            firstInvite[firstInvite.length - 1].choices.push(...inviteChoices);
            dialogs = firstInvite;
        } else {
            normalInvite[normalInvite.length - 1].choices.push(...inviteChoices);
            dialogs = normalInvite;
        }
    } else if (annualTournament.status === 'selecting') {
        // Get declined invitation dialog (for user company)
        if (companyData.status === 'declined') {
            dialogs = declined;
        } else {
            // Check if bribed
            if (!bribed) {
                beforeStartChoices.push(bribeChoice);
            }
            // Check if entries selected
            if (companyData && companyData['participantIds']) {
                entriesSelected[entriesSelected.length - 1].choices.push(...beforeStartChoices);
                dialogs = entriesSelected;
            } else {
                selectingEntries[selectingEntries.length - 1].choices.push(...beforeStartChoices);
                dialogs = selectingEntries;
            }
        }
    } else if (annualTournament.status === 'running') {
        const tournamentEvent = await getTournamentEvent(annualTournament);
        if (injuredParticipant) {
            dialogs = replacing;
        } else {
            // Runs before start of tournament
            if (tournamentEvent && tournamentEvent.name[tournamentEvent.name.length - 1] === '1') {
                dialogs = starting;
            }
            // Runs after tournament started
            else {
                if (event && event.name[event.name.length - 1] === '1') {
                    dialogs = runningNight1;
                } else {
                    dialogs = runningNight2;
                }
            }
        }
    }

    return dialogs;
}

function getAnnualTournamentDialogObjects(annualTournament, presidentName, entriesSample, participationPoints, injuredParticipant,
                                          bribeCost, numberOfEntries, participatingCompaniesText, normalInviteFirstText,
                                          entriesSampleNames, entriesVerb) {
    const numberOfEntriesWord = numberOfEntries !== 1 ? 'entries' : 'entry';
    const firstInvite = [
        {
            "choices": [
                {
                    "text": ["Pleased to meet you."],
                    "reply": {
                        "text": ["No need to be so formal, we're going to be in business!"],
                        "goToNextDialog": true
                    }
                },
                {
                    "text": ["Can I help you?"],
                    "reply": {
                        "text": ["Straight to the point, I like it."],
                        "goToNextDialog": true
                    }
                },
                {
                    "text": ["Why're you here?"],
                    "reply": {
                        "text": ["Business, of course."],
                        "goToNextDialog": true
                    }
                }
            ],
            "text": [`Hello there. I'm ${presidentName}, president of The Grand Invitational.`]
        },
        {
            "choices": [
                {
                    "text": ["No, what is it?"],
                    "reply": {
                        "text": [
                            "The Grand Invitational is a new tournament where talent from all over the world " +
                            "face off to see who is the best.",
                            "Superstars will represent their companies or the Indies, competing in dream matches " +
                            "and igniting company rivalries for the chance to write their names in the history books.",
                            "The Grand Invitational itself will be in charge of the booking and we plan to deliver the " +
                            "best possible show for the fans.",
                            "With substantial backing from our board of directors, we plan to run the tournament every year."],
                        "goToNextDialog": true
                    }
                },
                {
                    "text": ["Of course."],
                    "reply": {
                        "text": [
                            "Then you know how important it is. The first edition of The Grand Invitational will be talked " +
                            "about for ages!"],
                        "goToNextDialog": true
                    }
                }
            ],
            "text": [
                "Have you heard about The Grand Invitational?"
            ]
        },
        {
            "choices": [
                {
                    "text": ["I'm excited to be a part of it."],
                    "action": "acceptInvitation",
                    "highlight": "green",
                    "reply": {
                        "text": [
                            "Wonderful! The Grand Invitational will run at the start of next month. You can select your " +
                            "entries once you arrive and I will be available to answer any questions you have."]
                    }
                },
                {
                    "text": ["I don't think it's a good idea for us."],
                    "action": "declineInvitation",
                    "highlight": "red",
                    "reply": {
                        "text": [
                            "We didn't expect everyone to be on board for our first event. I'm sure once you see how " +
                            "well it does, you'll decide to participate next time."]
                    }
                }
            ],
            "text": [
                "I wanted to personally invite you to the inaugural edition of our tournament, which will be held next month.",
                `Besides the chance to win and establish your company's supremacy, we're ready to offer you a suitable ` +
                `payment of ${getPointsHtml(participationPoints)} for participating.`,
                "The Grand Invitational will be a one of a kind event that your company cannot miss, especially if you " +
                "don't want a competitor to claim all the glory.",
                "So, can we expect to see you there?"
            ]
        }
    ];
    const normalInvite = [
        {
            "choices": [
                {
                    "text": ["We'll be there."],
                    "action": "acceptInvitation",
                    "highlight": "green",
                    "reply": {
                        "text": ["Lovely! I'll see you there."]
                    }
                },
                {
                    "text": ["We can't make it."],
                    "action": "declineInvitation",
                    "highlight": "red",
                    "reply": {
                        "text": [
                            "Not the response I was looking for, but we'll still have a great show. I hope you will " +
                            "join us next time."]
                    }
                },
            ],
            "text": [
                normalInviteFirstText,
                `I wanted to invite you to the upcoming edition of the tournament, ${annualTournament.name}. We have ` +
                `prepared a financial package of ${getPointsHtml(participationPoints)} for your participation in the event.`,
                "It's shaping up to be quite the affair, one that your company shouldn't miss.",
                "Will we see you there?"]
        }
    ];
    const inviteChoices = [
        {
            "text": ["How does it work?"],
            "reply": {
                "text": [
                    "The Grand Invitational is a 16 person elimination tournament held over two nights. Companies select " +
                    "their participants right before the event starts, so you have a month to decide who to send.",
                    "The number of entries for companies depends on their reputation, with the remaining entries coming " +
                    "from the Indies."]
            }
        },
        {
            "text": ["Which companies are participating?"],
            "reply": {
                "text": [
                    participatingCompaniesText
                ]
            }
        },
        {
            "text": ["How are winners chosen?"],
            "reply": {
                "text": [
                    "Winners are decided by The Grand Invitational's booking committee. This means that your win/loss " +
                    " won't be affected.",
                    "I can't tell you exactly how the process works. I believe it has something to do with computers .. ",
                    "Suffice to say that the more popular a talent is, the more likely they are to win. That means it's " +
                    "best to send your top superstars!"]
            }
        },
        {
            "text": ["What does the winner get?"],
            "reply": {
                "text": [
                    "The winner is awarded the prestigious TGI trophy, as well as significant boosts to their status, " +
                    "while all participants benefit from increased exposure.",
                    "The winning company is also bound to gain some new fans."]
            }
        },
        {
            "text": ["Are there any rules for the tournament?"],
            "reply": {
                "text": [
                    "The Grand Invitational is held under pure wrestling rules, which means there are no managers, " +
                    "gimmick matches or dusty finishes.",
                    "In an effort to stay impartial, no company can send any staff of their own.",
                    "Finally, in any match, there is always the chance of injury. It is my obligation to tell you that " +
                    "The Grand Invitational cannot be held responsible for any injuries sustained during it."]
            }
        },
        {
            "text": ["How did this start?"],
            "reply": {
                "text": [
                    "In a wrestling world filled with competitions like Year-End Awards and Top 50 Rankings, we thought: " +
                    "why not have talent directly compete against each other?",
                    "We decided to host the tournament ourselves on neutral grounds. You can imagine if the bookers had " +
                    "to figure out who would win .. we'd never get started!",
                    "Investors came running once we told them how much fans would pay to see the top companies fight it " +
                    "out, and here we are."]
            }
        }
    ];
    const bribeChoice = {
        "text": ["How are the winners decided?"],
        "reply": {
            "text": [
                "The Grand Invitational's booking committee picks the winners. You know, I do happen to sit on the committee ..",
                `I could do you a favor and put in a good word for your superstars. How about you raise your chances of ` +
                `winning, for a modest fee of, let's say, ${getPointsHtml(bribeCost)}?`],
            "choices": [
                {
                    "text": ["Sounds like a good deal."],
                    "action": "bribePresident"
                },
                {
                    "text": ["I can't do that. That's cheating."],
                    "reply": {
                        "text": ["I was only going to talk to some people. Anyways, let's continue."]
                    }
                }
            ]
        }
    };
    const beforeStartChoices = [
        {
            "text": ["Which superstars are participating?"],
            "reply": {
                "text": [
                    "Oh, that's secret. Participants cannot be revealed until everyone makes their picks and the " +
                    "bracket is created. This prevents anyone from gaining an unfair advantage.",
                    "But, just because we're friends .. ",
                    `I overheard that ${entriesSampleNames} ${entriesVerb} on the entry list.`]
            }
        },
        {
            "text": ["How is the bracket made?"],
            "reply": {
                "text": [
                    "Participants are seeded based on their popularity. Companies are kept apart so that, ideally, " +
                    "the top two companies should face each other in the final."]
            }
        }
    ];
    const selectingEntries = [
        {
            "choices": [
                {
                    "text": ["I'd like to select my entries."],
                    "highlight": "green",
                    "reply": {
                        "text": [`Very well. Based on your company's reputation, we have given you ${numberOfEntries} ` +
                        `${numberOfEntriesWord} in the tournament.`],
                        "choices": [
                            {
                                "text": ["Okay."],
                                "action": "selectEntries",
                                "highlight": "green"
                            },
                            {
                                "text": ["Just a moment."],
                                "reply": {
                                    "text": ["Of course."]
                                }
                            }
                        ]
                    }
                }
            ],
            "text": [
                `Welcome to ${annualTournament.name}! We are so glad you could make it. The other companies are just 
                arriving as well.`,
                "Please make yourself comfortable and feel free to ask any questions you have about the tournament.",
                "Once you have decided on your entries, the tournament can start."
            ]
        }
    ];
    const declined = [
        {
            "choices": [],
            "text": [
                `Welcome to ${annualTournament.name}! Wait, you're not participating .. `,
                "Ah, you're here as a spectator. I see. I should go talk to the other companies."
            ]
        }
    ];
    const entriesSelected = [
        {
            "choices": [
                {
                    "text": ["I'm ready."],
                    "highlight": "green",
                    "reply": {
                        "text": ["Are you sure? The bracket will be created now."],
                        "choices": [
                            {
                                "text": ["Yes, let's start."],
                                "action": "startTournament",
                                "highlight": "green"
                            },
                            {
                                "text": ["Actually, hold on."],
                                "reply": {
                                    "text": ["We can wait a bit longer."]
                                }
                            }
                        ]
                    }
                }
            ],
            "text": [
                "Your entries have been finalized. Once you are ready, we can start the tournament."
            ]
        }
    ];
    const starting = [
        {
            "choices": [],
            "text": [
                "That's quite an interesting bracket! Let's go on to the event."
            ],
            "action": "startEvent"
        }
    ];
    const runningNight1 = [
        {
            "choices": [],
            "text": [
                "The tournament's going quite well, isn't it?"
            ],
            "action": "startEvent"
        }
    ];
    const runningNight2 = [
        {
            "choices": [],
            "text": [
                "We're getting close to crowning the winner! Let's continue to the event."
            ],
            "action": "startEvent"
        }
    ];
    let replacing;
    if (injuredParticipant) {
        replacing = [
            {
                "choices": [
                    {
                        "text": ["Okay."],
                        "action": "selectReplacement"
                    }
                ],
                "text": [
                    `I'm afraid that ${injuredParticipant.name} has suffered an injury .. I don't think we can have ` +
                    `${injuredParticipant.objectivePronoun} participate in the rest of the tournament. Fortunately, ` +
                    `you can select a replacement.`
                ]
            }
        ];
    }

    return {firstInvite, normalInvite, inviteChoices, bribeChoice, beforeStartChoices, selectingEntries, declined,
        entriesSelected, starting, runningNight1, runningNight2, replacing}
}

let otherDialogs = {
    "bribeAccepted": ["I'll do my best to sway opinions in the committee. And listen, let's keep this between us."],
    "bribeNotEnoughPoints": ["Sorry, but I don't think you have the funds for that."],
    "entriesSelectedFull": ["Thank you and good luck. You should see that we have sent the agreed upon fee for your participation."],
    "entriesSelectedNotFull": ["Not the amount we wanted, but we'll make do with some Indies. I hope you understand that we cannot give you the full fee we agreed upon."],
    "startTournament": ["Good, then let's begin."],
    "startTournamentIncompleteEntries": ["Unfortunately, some companies haven't finalized their entries yet. Please wait a moment."],
    "replacementAdded": ["Your replacement has been confirmed. I hope to see {0} again next time."],
    "replacementNotAdded": ["No problem. {0}, the loser from the previous round, will go through instead."]
}

function getPointsHtml(points) {
    return `<span class="blue margin-left-3 margin-right-3 display-inline-block">
                <img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> 
                ${points}
            </span>`;
}

export {presidentsData, getAnnualTournamentDialogs, otherDialogs}